var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8394 5.44625C19.0269 5.6337 19.0269 5.93762 18.8394 6.12508L5.83943 19.1251C5.65198 19.3125 5.34806 19.3125 5.16061 19.1251C4.97316 18.9376 4.97316 18.6337 5.16061 18.4463L18.1606 5.44625C18.3481 5.2588 18.652 5.2588 18.8394 5.44625Z",
    fill: "#08081B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.16061 5.44625C5.34806 5.2588 5.65198 5.2588 5.83943 5.44625L18.8394 18.4463C19.0269 18.6337 19.0269 18.9376 18.8394 19.1251C18.652 19.3125 18.3481 19.3125 18.1606 19.1251L5.16061 6.12508C4.97316 5.93762 4.97316 5.6337 5.16061 5.44625Z",
    fill: "#08081B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d10298a1eea92e7f491e96641d548dfb.svg";
export { ForwardRef as ReactComponent };